import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import classNames from 'classnames'
import { Dropdown, MenuProps } from 'antd'
import { languageMap } from 'i18n'

import LanguageIcon from 'assets/images/chevron-down-24.svg'

import styles from './style.module.scss'

const { ko, en, ja } = languageMap

const langMap: Record<string, any> = {
  ko,
  en,
  ja,
}

interface LanguageSwitcherProps {
  onChange?: (locale: string) => void
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = (props) => {
  const dispatch = useDispatch()
  // const locale = useSelector((state) => state.settings.locale, (objA, objB) => {
  //   return objA === objB;
  // });
  const locale = useSelector((state: any) => state.settings.general.locale)

  const changeLanguage = (e: any) => {
    const { key } = e

    dispatch({
      type: 'settings/SET_LOCALE',
      payload: {
        locale: key,
      },
    })

    if (props.onChange != null) {
      setTimeout(() => {
        props.onChange!(key)
      }, 70)
    }

    e.domEvent.stopPropagation()
  }

  const onClick = (e: React.MouseEvent) => {
    e.stopPropagation()
  }

  const langCode = locale.substr(0, 2)

  const language = langMap[langCode.toLowerCase()].name

  const menu: MenuProps = {
    selectedKeys: [locale],
    selectable: true,
    onClick: changeLanguage,
    items: [
      // {
      //   key: 'ko-KR',
      //   label: (
      //     <React.Fragment>
      //       <span className="text-uppercase font-size-12 mr-2">KO</span>
      //       한국어
      //     </React.Fragment>
      //   ),
      // },
      // {
      //   key: 'en-US',
      //   label: (
      //     <React.Fragment>
      //       <span className="text-uppercase font-size-12 mr-2">EN</span>
      //       English
      //     </React.Fragment>
      //   ),
      // },
      // Disable the laguages below - FR, RU, CN
      // {
      //   key: 'fr-FR',
      //   label: (
      //     <React.Fragment>
      //       <span className="text-uppercase font-size-12 mr-2">FR</span>
      //       French
      //     </React.Fragment>
      //   )
      // },
      // {
      //   key: 'ru-RU',
      //   label: (
      //     <React.Fragment>
      //       <span className="text-uppercase font-size-12 mr-2">RU</span>
      //       Русский
      //     </React.Fragment>
      //   )
      // },
      // {
      //   key: 'zh-CN',
      //   label: (
      //     <React.Fragment>
      //       <span className="text-uppercase font-size-12 mr-2">CN</span>
      //       简体中文
      //     </React.Fragment>
      //   )
      // },
    ],
  }

  menu.items = Object.entries(langMap).map(([key, value]) => {
    return {
      key: value.code,
      label: (
        <React.Fragment>
          <span className="text-uppercase font-size-12 mr-2">{key.toUpperCase()}</span>
          {value.name}
        </React.Fragment>
      ),
    }
  })

  return (
    <Dropdown
      className={styles.languageSwitcher}
      overlayClassName={classNames('contextMenu')}
      menu={menu}
      trigger={['click']}
      placement="bottomRight"
    >
      <div className={styles.dropdown} onClick={onClick}>
        <span className="text">{language}</span>
        <img src={LanguageIcon} alt="language" />
      </div>
    </Dropdown>
  )
}

export default LanguageSwitcher
